import ajax from '../utils/request'
const mediumApi = {
    /********************************视频相关接口*********************************** */
    creatMediumList(params) {
      return ajax({
          url: '/api/video/sets/create',
          type: 'post',
          params
      })
  },
  updateMediumList(params) {
    return ajax({
        url: '/api/video/sets/update',
        type: 'post',
        params
    })
},
mediumBatchCreate(params) {
  return ajax({
    url: '/api/media/batch/create',
    type: 'post',
    params
  })
},
mediumBatchDelete(params) {
  return ajax({
    url: '/api/media/batch/delete',
    type: 'post',
    params
  })
},
taskPointBatchUpdate(params) {
  return ajax({
    url: '/api/task/point/batch/update',
    type: 'post',
    params
  })
},
taskPointBatchDelete(params) {
  return ajax({
    url: '/api/task/point/batch/delete',
    type: 'post',
    params
  })
},
taskPointUpdate(params) {
  return ajax({
    url: '/api/task/point/update',
    type: 'post',
    params
  })
},
taskFillingCreate(params) {
  return ajax({
    url: '/api/task/filling/create',
    type: 'post',
    params
  })
},
taskFillingBatchDelete(params) {
  return ajax({
    url: '/api/task/filling/batch/delete',
    type: 'post',
    params
  })
},
taskFillingBatchUpdate(params) {
  return ajax({
    url: '/api/task/filling/batch/update',
    type: 'post',
    params
  })
},
taskFillingPass(params) {
  return ajax({
    url: '/api/task/filling/pass',
    type: 'post',
    params
  })
},
taskFillingSave(params) {
  return ajax({
    url: '/api/task/filling/save',
    type: 'post',
    params
  })
},
taskFillingUpdate(params) {
  return ajax({
    url: '/api/task/filling/update',
    type: 'post',
    params
  })
},
taskFillingList(params) {
  return ajax({
    url: '/api/task/filling/list',
    type: 'get',
    params
  })
},
taskPointList(params) {
  return ajax({
    url: '/api/task/point/list',
    type: 'get',
    params
  })
},
videoUpdateAuto(params) {
  return ajax({
    url: '/api/video/update/auto',
    type: 'post',
    params
  })
},
taskPointBatchCreate(params) {
  return ajax({
    url: '/api/task/point/batch/create',
    type: 'post',
    params
  })
},
authAdminUserWorkstate(params) {
  return ajax({
    url: '/api/auth/admin/user/workstate',
    type: 'get',
    params
  })
},
taskFillingAccept(params) {
  return ajax({
    url: '/api/task/filling/accept',
    type: 'post',
    params
  })
},
}
export default mediumApi

